import type {
  WorkspaceNode,
  WorkspaceNodeType,
  WorkspaceViewMode,
} from "../../../types/workspace";

export type WorkspaceChildActionKind = "strategy" | "report" | "simulation";

export type WorkspaceChildAddMode = "create" | "existing";

export type WorkspaceChildAction = {
  kind: WorkspaceChildActionKind;
  mode: WorkspaceChildAddMode;
  label: string;
};

function actionsForKinds(kinds: WorkspaceChildActionKind[]): WorkspaceChildAction[] {
  const labels: Record<WorkspaceChildActionKind, { create: string; existing: string }> = {
    strategy: { create: "Create strategy", existing: "Add existing strategy" },
    report: { create: "Create report", existing: "Add existing report" },
    simulation: { create: "Create simulation", existing: "Add existing simulation" },
  };
  return kinds.flatMap((kind) => [
    { kind, mode: "create" as const, label: labels[kind].create },
    { kind, mode: "existing" as const, label: labels[kind].existing },
  ]);
}

const CHILD_KINDS: Record<WorkspaceNodeType, WorkspaceChildActionKind[]> = {
  account: ["strategy", "report", "simulation"],
  strategy: ["report"],
  report: ["simulation"],
  simulation: [],
  policy: [],
  combined_policy: [],
  combined_simulation: [],
};

export function workspaceChildActionsForNode(
  node: WorkspaceNode,
  options?: { viewMode?: WorkspaceViewMode }
): WorkspaceChildAction[] {
  if (options?.viewMode === "strategy") return [];
  return actionsForKinds(CHILD_KINDS[node.type] ?? []);
}

export function canOpenWorkspaceNodeDetail(node: WorkspaceNode): boolean {
  return node.type !== "account";
}
